import { render, staticRenderFns } from "./courseEditTimeline_new.vue?vue&type=template&id=0f60d88e&scoped=true"
import script from "./courseEditTimeline_new.vue?vue&type=script&lang=js"
export * from "./courseEditTimeline_new.vue?vue&type=script&lang=js"
import style0 from "./courseEditTimeline_new.vue?vue&type=style&index=0&id=0f60d88e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f60d88e",
  null
  
)

export default component.exports